import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary: 'border-transparent bg-[#D447FB]/10 text-[#D447FB]',
        destructive: 'border-transparent bg-[#FF677B]/10 text-[#FF677B]',
        outline: 'text-foreground',
        success: 'border-transparent bg-[#0074F4]/10 text-[#0074F4]',
        warning: 'border-transparent bg-[#8B47FB]/10 text-[#8B47FB]',
        info: 'border-transparent bg-[#8B47FB]/10 text-[#8B47FB]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
